<template>
  <div style="margin-top:20px">
    <el-form ref="form" label-width="100px" :model="form" disabled>
      <el-form-item label="UUID" style="margin-right:15px">
        <el-input v-model="form.code" />
      </el-form-item>
      <el-form-item label="关联code，余额支付code" style="margin-right:15px">
        <el-input v-model="form.relatedCode" />
      </el-form-item>
      <el-form-item label="0余额支付" style="margin-right:15px">
        <el-input v-model="form.shareType" />
      </el-form-item>
      <el-form-item label="退款付方类型，即原支付单收方 商户(MERCHANT)、平台(PLATFORM)" style="margin-right:15px">
        <el-input v-model="form.participantType" />
      </el-form-item>
      <el-form-item label="退款付方id，即原支付单收方 如果是商户，则填入merchantId,如果是平台，则填入isvOrgId" style="margin-right:15px">
        <el-input v-model="form.participantId" />
      </el-form-item>
      <el-form-item label="关联网商订单号,原支付订单号" style="margin-right:15px">
        <el-input v-model="form.relateOrderNo" />
      </el-form-item>
      <el-form-item label="关联网商支付流水号,支付流水号：1）如果大额来账创建订单类型为单次订单，可不填.2）如果大额来账创建订单类型为订单累计，则必填" style="margin-right:15px">
        <el-input v-model="form.relateTransNo" />
      </el-form-item>
      <el-form-item label="退款外部交易号。由合作方生成，同笔退款交易，交易状态未明需要重试时，使用同一个交易号。" style="margin-right:15px">
        <el-input v-model="form.outRefundNo" />
      </el-form-item>
      <el-form-item label="订单退款金额。向渠道退款金额(金额为分)" style="margin-right:15px">
        <el-input v-model="form.refundAmount" />
      </el-form-item>
      <el-form-item label="退款原因" style="margin-right:15px">
        <el-input v-model="form.refundReason" />
      </el-form-item>
      <el-form-item label="状态，SUCCESS：成功,FAIL：失败,DEALING:处理中" style="margin-right:15px">
        <el-input v-model="form.status" />
      </el-form-item>
      <el-form-item label="退款网商订单号" style="margin-right:15px">
        <el-input v-model="form.refundOrderNo" />
      </el-form-item>
      <el-form-item label="退款完成时间（成功时出现）YYYYMMDDhhmmss" style="margin-right:15px">
        <el-input v-model="form.refundFinishDate" />
      </el-form-item>
      <el-form-item label="渠道退款单号（聚合 ）" style="margin-right:15px">
        <el-input v-model="form.channelRefundOrderNo" />
      </el-form-item>
      <el-form-item label="商户实际退款金额，聚合且退款成功时时出现" style="margin-right:15px">
        <el-input v-model="form.participantActualRefundAmount" />
      </el-form-item>
      <el-form-item label="扩展信息,Map的json序列化后Base64" style="margin-right:15px">
        <el-input v-model="form.extInfo" />
      </el-form-item>
      <el-form-item label="备注" style="margin-right:15px">
        <el-input v-model="form.memo" />
      </el-form-item>
      <el-form-item label="错误码" style="margin-right:15px">
        <el-input v-model="form.errorCode" />
      </el-form-item>
      <el-form-item label="错误描述" style="margin-right:15px">
        <el-input v-model="form.errorDesc" />
      </el-form-item>
      <el-form-item label="退单表code" style="margin-right:15px">
        <el-input v-model="form.orderDetailRefundCode" />
      </el-form-item>
      <el-form-item label="运输单code" style="margin-right:15px">
        <el-input v-model="form.orderDetailCode" />
      </el-form-item>
      <el-form-item label="运输单号" style="margin-right:15px">
        <el-input v-model="form.orderDetailNumber" />
      </el-form-item>
      <el-form-item label="收款方code" style="margin-right:15px">
        <el-input v-model="form.partyCode" />
      </el-form-item>
      <el-form-item label="收款方姓名" style="margin-right:15px">
        <el-input v-model="form.partyName" />
      </el-form-item>
      <el-form-item label="收款方手机号" style="margin-right:15px">
        <el-input v-model="form.partyPhone" />
      </el-form-item>
      <el-form-item label="机构code" style="margin-right:15px">
        <el-input v-model="form.branchCode" />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import request from '@/utils/request'
export default {
  name: 'MybankPayRefundDetail',
  data() {
    return {
      emptyForm: {},
      form: {
        code: '',
        relatedCode: '',
        shareType: '',
        participantType: '',
        participantId: '',
        relateOrderNo: '',
        relateTransNo: '',
        outRefundNo: '',
        refundAmount: '',
        refundReason: '',
        status: '',
        refundOrderNo: '',
        refundFinishDate: '',
        channelRefundOrderNo: '',
        participantActualRefundAmount: '',
        extInfo: '',
        memo: '',
        errorCode: '',
        errorDesc: '',
        orderDetailRefundCode: '',
        orderDetailCode: '',
        orderDetailNumber: '',
        partyCode: '',
        partyName: '',
        partyPhone: '',
        branchCode: ''
      }
    }
  },
  created() {
    //保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form))
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      //查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      request({
        url: `/arpa-cloud-platform/mybankPayRefund/${code}`,
        method: 'get'
      }).then((response) => {
        this.form = response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin-top: 50px;
}
</style>
